export default __webpack_public_path__ + "static/media/flap.bd72939c.png";